export class FileInfo {
    fileName = "";
    fileExists = false;
}
